'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.util = undefined;

var _util = require('./util.js');

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.util = util;


//////////////////
// WEBPACK FOOTER
// ./~/uport-transports/lib/message/index.js
// module id = 905
// module chunks = 0